import { Component, effect, input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { DealDashboardDetails } from 'src/app/models/classes/deal-dashboard-details.class';
import { DateFormatPipe } from 'src/app/pipes/date-format.pipe';
import { FinancialPerformanceWidgetComponent } from './financial-performance-widget/financial-performance-widget.component';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CoInvestmentDashboard } from 'src/app/models/classes/co-investment-dashboard.class';
import { CurrencyFormatPipe } from 'src/app/pipes/currency-format.pipe';
import { CoInvestmentDetails } from 'src/app/models/classes/co-investment-details.class';
import { ToNumberPipe } from 'src/app/pipes/to-number.pipe';
import { ToStringPipe } from 'src/app/pipes/to-string.pipe';
import { List } from 'lodash';

@Component({
  selector: 'app-case-study',
  imports: [
    MatIconModule,
    DateFormatPipe,
    MatChipsModule,
    FinancialPerformanceWidgetComponent,
    CommonModule,
    CurrencyFormatPipe,
    DecimalPipe,
    ToNumberPipe,
    ToStringPipe
  ],
  templateUrl: './case-study.component.html'
})
export class CaseStudyComponent {
  investmentSummary!: CoInvestmentDetails;
  readonly dealSummary = input<DealDashboardDetails>();
  readonly caseStudyDetails = input<CoInvestmentDashboard>();
  investmentHighlights!: (string | unknown)[];
  statusAndPerformance!: (string | unknown)[];
  investmentSummaryItems!: { label: string; value: string | number; isDate?: boolean; isMillions?: boolean; isMultiple?: boolean }[];
  confidential = 'Confidential';
  isConfidential = false;

  private readonly rebuildSummary = effect(() => {
    const caseStudyDetails = this.caseStudyDetails();
    if (caseStudyDetails) {
      this.investmentSummary = caseStudyDetails.summary;
      this.investmentHighlights = this.splitNarrativeIntoArray(caseStudyDetails.investmentHighlightsNarrative);
      this.statusAndPerformance = this.splitNarrativeIntoArray(caseStudyDetails.performanceNarrative);
      this.isConfidential = this.investmentSummary.confidential ?? false;
      this.investmentSummaryItems = [
        { label: 'Investment Date', value: this.investmentSummary.investmentDate, isDate: true },
        { label: 'Sponsor', value: this.investmentSummary.investmentManagerName },
        { label: 'Deal Type', value: this.investmentSummary.strategy },
        { label: 'Industry', value: this.investmentSummary.industry },
        { label: 'Geography', value: this.investmentSummary.region },
        { label: 'Total GCM Commitment', value: this.isConfidential ? this.confidential : this.investmentSummary.totalGcmGrosvenorCommitment as number, isMillions: !this.isConfidential },
        { label: 'Total Enterprise Value', value: this.isConfidential ? this.confidential : this.investmentSummary.entryTotalEnterpriseValue as number, isMillions: !this.isConfidential },
        { label: 'Entry Valuation', value: this.isConfidential ? this.confidential : this.investmentSummary.entryValuationMultiple as number, isMultiple: !this.isConfidential },
        { label: `Entry ${this.investmentSummary.netDebtLabel}`, value: this.isConfidential ? this.confidential : this.investmentSummary.entryNetDebt as number, isMillions: !this.isConfidential },
        { label: 'Entry Net Leverage', value: this.isConfidential ? this.confidential : this.investmentSummary.entryNetLeverage as number, isMultiple: !this.isConfidential },
        { label: `Entry ${this.investmentSummary.valuationDriverLabel}`, value: this.isConfidential ? this.confidential : this.investmentSummary.entryValuationDriverValue as number, isMillions: !this.isConfidential }
      ];
    }
  });

  splitNarrativeIntoArray(narrative: List<string>) {
    return Array.from(narrative).flatMap(item => {
      if (typeof item === 'string' && item.includes('*')) {
        return item.split('*').map(part => part.trim()).filter(part => part !== '');
      } else if (typeof item === 'string') {
        return [item];
      } else {
        return [item];
      }
    });
  }
}
